import { call, put, select, takeLatest } from "redux-saga/effects";

import { API } from "../../api";
import {
  sendForgotRequest,
  sendForgotRequestFailuer,
  sendForgotRequestSuccess,
  setNewPassword,
  setNewPasswordFailuer,
  setNewPasswordSuccess
} from "../reducers/passwordRestorationSlice";

import { errorHandler } from "./common";

function* forgottenPasswordSaga ({
  payload: { login },
}: {
    payload: {
      login: string;
      onSuccess?: () => void;
      onFailure?: (error: any) => void;
    };
  }) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/auth/admin/forgot-password`,
      {
        login
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(sendForgotRequestSuccess());
    // onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield forgottenPasswordSaga({
          payload: { login },
        });
      },
      *callback () {
        yield put(sendForgotRequestFailuer(error));
        // onFailure(error);
      },
    });
  }
}

function* newPasswordSaga ({
  payload: { password, authToken, onSuccess, onFailure },
}: {
    payload: {
      password: string;
      authToken: string;
      onSuccess: () => void;
      onFailure: (error: any) => void;
    };
  }) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.patch,
      `/auth/forgot-password`,
      {
        password,
        token: authToken,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(setNewPasswordSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield newPasswordSaga({
          payload: { password, authToken, onSuccess, onFailure},
        });
      },
      *callback () {
        yield put(setNewPasswordFailuer(error));
        onFailure(error);
      },
    });
  }
}

export function* restorePasswordSaga () {
  // @ts-ignore
  yield takeLatest(sendForgotRequest().type, forgottenPasswordSaga);
  // @ts-ignore
  yield takeLatest(setNewPassword().type, newPasswordSaga);
}